import { render } from "./Stats.vue?vue&type=template&id=550f2a13"
import script from "./Stats.vue?vue&type=script&setup=true&lang=js"
export * from "./Stats.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/home/forge/retail.digitalhq.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/admin/ui/Pages/Graphs/Stats.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "550f2a13"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('550f2a13', __exports__)) {
    api.reload('550f2a13', __exports__)
  }
  
  module.hot.accept("./Stats.vue?vue&type=template&id=550f2a13", () => {
    api.rerender('550f2a13', render)
  })

}


export default __exports__